import { useState, useEffect, useCallback } from 'react'

const useResponsiveTimer = (wrapperRef) => {
  const [timerStyles, setTimerStyles] = useState({
    full: {
      h1: { 
        fontSize: '260px',
        margin: '30px 0',
      },
      h2: { 
        fontSize: '64px', 
      },
      h3: { 
        fontSize: '48px', 
      },
    },
    split: {
      h1: { 
        fontSize: '260px',
        margin: '30px 0',
      },
      h2: { 
        fontSize: '52px', 
      },
      h3: { 
        fontSize: '34px', 
      },
    }
  })

  const calculateTimerStyles = useCallback((height) => {
    let full = {}
    if (height >= 1100) {
      full = {
        h1: { 
          fontSize: '300px', 
          margin: '30px 0' 
        },
        h2: { 
          fontSize: '88px', 
        },
        h3: { 
          fontSize: '70px', 
        },
      }
    } else if (height >= 1000) {
      full = {
        h1: { 
          fontSize: '280px',
          margin: '25px 0',
        },
        h2: { 
          fontSize: '80px', 
        },
        h3: { 
          fontSize: '65px', 
        },
      }
    } else if (height >= 900) {
      full = {
        h1: { 
          fontSize: '230px',
          margin: '20px 0',
        },
        h2: { 
          fontSize: '75px', 
        },
        h3: { 
          fontSize: '60px', 
        },
      }
    } else if (height >= 800) {
      full = {
        h1: { 
          fontSize: '190px',
          margin: '15px 0',
        },
        h2: { 
          fontSize: '70px', 
        },
        h3: { 
          fontSize: '50px', 
        },
      }
    } else if (height >= 700) {
      full = {
        h1: { 
          fontSize: '130px',
          margin: '10px 0',
        },
        h2: { 
          fontSize: '62px', 
        },
        h3: { 
          fontSize: '44px', 
        },
      }
    } else {
      full = {
        h1: { 
          fontSize: '80px',
          margin: '15px 0',
        },
        h2: { 
          fontSize: '52px', 
        },
        h3: { 
          fontSize: '38px', 
        },
      }
    }

    let split = {}
    if (height >= 1100) {
      split = {
        h1: { 
          fontSize: '230px',
          margin: '25px 0',
        },
        h2: { 
          fontSize: '72px', 
        },
        h3: { 
          fontSize: '54px', 
        },
      }
    } else if (height >= 1000) {
      split = {
        h1: { 
          fontSize: '190px',
          margin: '20px 0',
        },
        h2: { 
          fontSize: '65px', 
        },
        h3: { 
          fontSize: '50px', 
        },
      }
    } else if (height >= 900) {
      split = {
        h1: { 
          fontSize: '160px',
          margin: '10px 0',
        },
        h2: { 
          fontSize: '60px', 
        },
        h3: { 
          fontSize: '45px', 
        },
      }
    } else if (height >= 800) {
      split = {
        h1: { 
          fontSize: '120px',
          margin: '10px 0',
        },
        h2: { 
          fontSize: '52px', 
        },
        h3: { 
          fontSize: '38px', 
        },
      }
    } else if (height >= 700) {
      split = {
        h1: { 
          fontSize: '80px',
          margin: '5px 0',
        },
        h2: { 
          fontSize: '47px', 
        },
        h3: { 
          fontSize: '34px', 
        },
      }
    } else {
      split = {
        h1: { 
          fontSize: '50px',
          margin: '5px 0',
        },
        h2: { 
          fontSize: '45px', 
        },
        h3: { 
          fontSize: '32px', 
        },
      }
    }

    return { full, split }
  }, [])

  useEffect(() => {
    if (!wrapperRef?.current) return

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { height } = entry.contentRect
        const newStyles = calculateTimerStyles(height)
        setTimerStyles(newStyles)
      }
    })

    resizeObserver.observe(wrapperRef.current)

    const initialHeight = wrapperRef.current.clientHeight
    const initialStyles = calculateTimerStyles(initialHeight)
    setTimerStyles(initialStyles)

    return () => {
      resizeObserver.disconnect()
    }
  }, [wrapperRef, calculateTimerStyles])

  return timerStyles
}

export default useResponsiveTimer